export const PlatformEnums = {
  EFXLite: "EFXLite",
  EFXPro: "EFXPro",
  MT5: "MT5",
};
